<div class="modal" id="modal">
    <div class="modal-content">
        <bari-busy [busy]="busy" [absolute]="true"></bari-busy>
        <div class="modal-header">
            <bari-button icon="times" iconColor="#000" class="close" hover="background" *ngIf="closeicon" (click)="closeModal()"></bari-button>
            <ng-content select="[modal-header]"></ng-content>
        </div>
        <div class="modal-body">
            <ng-content select="[modal-body]"></ng-content>
        </div>
        <div class="modal-footer">
            <ng-content select="footer"></ng-content>
        </div>
    </div>
</div>
